<template>
    <div class="footer_container">
        <footer class="text-center text-muted small py-3 custom_footer">
      &copy; 2025 Tangerine. All rights reserved.
    </footer>
    </div>
</template>

<script>
export default{
    name:"FooterView"
}
</script>

<style scoped>

.custom_footer {
  height: 100px;
  background-color: orange;
}
</style>